module.exports = __webpack_public_path__ + "assets/breakit-logo-white.6863caa1.svg";


//////////////////
// WEBPACK FOOTER
// ../source/assets/svgs/breakit-logo-white.svg
// module id = 1637
// module chunks = 10